import { render, staticRenderFns } from "./UserCheckinConfig.vue?vue&type=template&id=28d41d0b&scoped=true&lang=pug&"
import script from "./UserCheckinConfig.vue?vue&type=script&lang=ts&"
export * from "./UserCheckinConfig.vue?vue&type=script&lang=ts&"
import style0 from "./UserCheckinConfig.vue?vue&type=style&index=0&id=28d41d0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d41d0b",
  null
  
)

export default component.exports